import { render, staticRenderFns } from "./jingdou.vue?vue&type=template&id=7a1a6d69&scoped=true"
import script from "./jingdou.vue?vue&type=script&lang=js"
export * from "./jingdou.vue?vue&type=script&lang=js"
import style0 from "./jingdou.vue?vue&type=style&index=0&id=7a1a6d69&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1a6d69",
  null
  
)

export default component.exports